// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import toast from 'react-hot-toast'
// import { LoadingDots } from "../Components/LoadingDots";
// import accountService from "../Services/accountService";
// import accountTransfersService from "../Services/accountsTransferService";
// import { FaArrowLeft } from "react-icons/fa6";
// import moment from "moment";

// const AddJournalTransaction = () => {
//     const navigate = useNavigate()
//     const [responseError, setResponseError] = useState('')
//     const [accounts, setAccounts] = useState([])
//     const [loading, setLoading] = useState(false)
//     const [data, setData] = useState({
//         from_account: "",
//         to_account: "",
//         amount: "",
//         date: "",
//         note: ""
//     });

//     const [errors, setErrors] = useState({
//         from_account: false,
//         to_account: false,
//         amount: false,
//         date: false,
//         note: false
//     })

//     const [regex, setRegex] = useState({
//         from_account: /.{1,50}$/,
//         to_account: /.{1,50}$/,
//         amount: /.{1,50}$/,
//         date: /.{1,50}$/,
//         note: /.{1,50}$/
//     })
//     const [isOpen, setIsOpen] = useState(false);
//     const [dropdownOpen, setDropDownOpen] = useState(false)

//     const toggleDropdown = () => {
//         setIsOpen(!isOpen)
//     }

//     const accountDropdown = () => {
//         setDropDownOpen(!dropdownOpen)
//     }

//     useEffect(() => {
//         accountService.fetchAllActiveAccounts().then((res) => {
//             setAccounts(res.accounts)
//         })
//     }, [])

//     const handleChange = (v, n) => {
//         if (n === 'date' && v > moment().format("YYYY-MM-DD")) {
//             toast.error('Cannot select future date', { id: "1" });
//             return;
//         }
//         if (n === 'amount' && v < 0) {
//             return;
//         }
//         setResponseError('')
//         setData(d => ({ ...d, [n]: v }))
//         if (v.length > 0) {
//             setErrors(prevState => ({ ...prevState, [n]: false }))
//         }
//     }

//     const handleSubmit = () => {
//         let hasError = false;
//         Object.keys(data).map(v => {
//             if (!regex[v]?.test(data[v])) {
//                 setErrors(prevState => ({ ...prevState, [v]: true }))
//                 hasError = true
//             }
//         })

//         if (hasError) {
//             toast.error('Please fill the form correctly', { id: "1" });
//         } else {
//             setLoading(true)
//             accountTransfersService.create(data).then(res => {
//                 if (res.responseCode === 201) {
//                     toast.error(res.message, { id: "3" });
//                     setLoading(false)
//                     return;
//                 }
//                 setLoading(false)
//                 toast.success('Journal Transaction Added Successfully', { id: "2" })
//                 navigate('/journals')
//             })
//         }
//     }

//     const handleKeyDown = (event) => {
//         if (event.key === 'Enter') {
//             handleSubmit();
//         }
//     };
//     return (
//         <main className='mx-16 my-10 bg-gray-50 rounded-lg border py-8 px-20'>
//             <h1 className='text-center font-bold text-2xl text-gray-700 uppercase'>Add Journal Transaction</h1>

//                     <div className='mt-10'>
//                         <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8">
//                             <div>
//                                 <label
//                                     className="primary-label">
//                                     From (Account) :
//                                 </label>
//                                 <div className="relative w-full bg-white">
//                                     <button
//                                     type="button"
//                                     className={`flex justify-between items-center primary-input ${errors['account'] ? "!border-red-600" : ""}`}
//                                     onClick={toggleDropdown}
//                                     >
//                                     <span className={`${data.account ? "text-gray-800" : "text-gray-400"}`}>
//                                         {data.customer
//                                         ? accounts.find((a) => a.id === data.account)?.account_name
//                                         : "Select From Account"}
//                                     </span>
//                                     <svg
//                                         className={`fill-current h-4 w-4 ml-2 transition-transform duration-300 ${
//                                         isOpen ? "rotate-180" : ""
//                                         }`}
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         viewBox="0 0 20 20"
//                                     >
//                                         <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
//                                     </svg>
//                                     </button>

//                                     <ul
//                                     className={`absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto transition-all duration-200 ${
//                                         isOpen ? "block" : "hidden"
//                                     }`}
//                                     >
//                                     {accounts.length > 0 ? (
//                                         accounts.map((account) => (
//                                         <li
//                                             key={account.id}
//                                             className="px-4 py-2 hover:bg-gray-100 cursor-pointer w-full"
//                                             onClick={() => {
//                                             const fakeEvent = {
//                                                 target: {
//                                                 name: "account",
//                                                 value: account.id,
//                                                 },
//                                             };
//                                             handleChange(fakeEvent);
//                                             setIsOpen(false);
//                                             }}
//                                         >
//                                           {account.account_name} - {account.account_title}
//                                         </li>
//                                         ))
//                                     ) : (
//                                         <li className="px-4 py-2 text-gray-400">No Data Available</li>
//                                     )}
//                                     </ul>
//                                  </div>
//                                 </div>
//                                 <div>
//                                 <label
//                                     className="primary-label">
//                                     Account
//                                 </label>
//                                 <div className="relative w-full bg-white">
//                                     <button
//                                     type="button"
//                                     className={`flex justify-between items-center primary-input ${errors['acc'] ? "!border-red-600" : ""}`}
//                                     onClick={accountDropdown}
//                                     >
//                                     <span className={`${data.account ? "text-gray-800" : "text-gray-400"}`}>
//                                         {data.customer
//                                         ? accounts.find((a) => a.id === data.account)?.account_name
//                                         : "Select Account"}
//                                     </span>
//                                     <svg
//                                         className={`fill-current h-4 w-4 ml-2 transition-transform duration-300 ${
//                                         dropdownOpen ? "rotate-180" : ""
//                                         }`}
//                                         xmlns="http://www.w3.org/2000/svg"
//                                         viewBox="0 0 20 20"
//                                     >
//                                         <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
//                                     </svg>
//                                     </button>

//                                     <ul
//                                     className={`absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto transition-all duration-200 ${
//                                         dropdownOpen ? "block" : "hidden"
//                                     }`}
//                                     >
//                                     {accounts.length > 0 ? (
//                                         accounts.map((acc) => (
//                                         <li
//                                             key={acc.id}
//                                             className="px-4 py-2 hover:bg-gray-100 cursor-pointer w-full"
//                                             onClick={() => {
//                                             const fakeEvent = {
//                                                 target: {
//                                                 name: "acc",
//                                                 value: acc.id,
//                                                 },
//                                             };
//                                             handleChange(fakeEvent);
//                                             setDropDownOpen(false);
//                                             }}
//                                         >
//                                           {acc.account_name} - {acc.account_title}
//                                         </li>
//                                         ))
//                                     ) : (
//                                         <li className="px-4 py-2 text-gray-400">No Account available</li>
//                                     )}
//                                     </ul>
//                                  </div>
//                                 </div>
//                                 <div>
//                                     <label
//                                         className="primary-label">
//                                         Amount
//                                     </label>
//                                     <input
//                                         value={data.amount}
//                                         name="amount"
//                                         type="number"
//                                         onChange={(e) => handleChange(e.target.value, e.target.name)}
//                                         onKeyDown={handleKeyDown}
//                                         className={`primary-input ${errors['amount'] ? "!border-red-600" : ""}`}
//                                     />
//                                 </div>
//                             </div>
//                         <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8 mt-4">
//                             <div>
//                                 <label
//                                     className="primary-label">
//                                     Date
//                                 </label>
//                                 <input
//                                     value={data.date}
//                                     type="date"
//                                     name="date"
//                                     onChange={(e) => handleChange(e.target.value, e.target.name)}
//                                     placeholder="date"
//                                     onKeyDown={handleKeyDown}
//                                     className={`primary-input ${errors['date'] ? "!border-red-600" : ""}`}
//                                 />
//                             </div>
//                         </div>
//                         <div className="grid grid-cols-1 mt-4">
//                             <div>
//                                 <div>
//                                     <label
//                                         className="primary-label">
//                                         Note
//                                     </label>
//                                     <textarea
//                                         value={data.note}
//                                         name="note"
//                                         onChange={(e) => handleChange(e.target.value, e.target.name)}
//                                         onKeyDown={handleKeyDown}
//                                         className={`primary-input ${errors['note'] ? "!border-red-600" : ""}`}
//                                     />
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="flex items-center justify-center mt-12">
//                         <button
//                             onClick={() => handleSubmit()}
//                             className={`button-primary !w-[210px]`}
//                         >
//                           Add Journal Transaction
//                         </button>
//                      </div>
//                    </div>
//                 </main>
//     );
// };

// export default AddJournalTransaction;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { LoadingDots } from "../Components/LoadingDots";
import accountService from "../Services/accountService";
import accountTransfersService from "../Services/accountsTransferService";
import { FaArrowLeft } from "react-icons/fa6";
import moment from "moment";
import Dropdown from "../Components/Dropdown";

const AddJournalTransaction = () => {
  const navigate = useNavigate();
  const [responseError, setResponseError] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    from_account: "",
    to_account: "",
    amount: "",
    date: "",
    note: "",
  });

  const [errors, setErrors] = useState({
    from_account: false,
    to_account: false,
    amount: false,
    date: false,
    note: false,
  });

  const [regex] = useState({
    from_account: /.{1,50}$/,
    to_account: /.{1,50}$/,
    amount: /^(\d+(\.\d{1,2})?)$/, // for numeric amount
    date: /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
    note: /.{0,200}$/, // Optional, max 200 characters
  });

  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropDownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const accountDropdown = () => {
    setDropDownOpen(!dropdownOpen);
  };

  useEffect(() => {
    accountService.fetchAllActiveAccounts().then((res) => {
      setAccounts(res.accounts);
    });
  }, []);

  const handleChange = (v, n) => {
    if (n === "date" && v > moment().format("YYYY-MM-DD")) {
      toast.error("Cannot select future date", { id: "1" });
      return;
    }
    if (n === "amount" && v < 0) {
      return;
    }
    setResponseError("");
    setData((d) => ({ ...d, [n]: v }));
    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }
  };

  const handleSubmit = () => {
    let hasError = false;

    Object.keys(data).forEach((v) => {
      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      setLoading(true);
      accountTransfersService.create(data).then((res) => {
        if (res.responseCode === 201) {
          toast.error(res.message, { id: "3" });
          setLoading(false);
          return;
        }
        setLoading(false);
        toast.success("Journal Transaction Added Successfully", { id: "2" });
        navigate("/journals");
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      <p className="font-bold text-3xl text-secondary">
        Add Journal Transaction
      </p>

      <div className="mt-10">
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-4">
          {/* From Account */}
          <div>
            <label className="primary-label">From Account :</label>
            <Dropdown
              selected={data.from_account}
              placeholder="Select From Account"
              onChange={(value) => handleChange(value, "from_account")}
              options={accounts.map((account) => ({
                label: `${account.account_name} - ${account.account_title}`,
                value: account.id,
              }))}
            />
          </div>

          {/* To Account */}
          <div>
            <label className="primary-label">To Account :</label>
            <Dropdown
              selected={data.to_account}
              placeholder="Select To Account"
              onChange={(value) => handleChange(value, "to_account")}
              options={accounts.map((acc) => ({
                label: `${acc.account_name} - ${acc.account_title}`,
                value: acc.id,
              }))}
            />
          </div>

          {/* Amount */}
          <div>
            <label className="primary-label">Amount</label>
            <input
              value={data.amount}
              name="amount"
              type="number"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["amount"] ? "!border-red-600" : ""
              }`}
            />
          </div>
        </div>

        {/* Date */}
        <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8 mt-4">
          <div>
            <label className="primary-label">Date</label>
            <input
              value={data.date}
              type="date"
              name="date"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["date"] ? "!border-red-600" : ""
              }`}
            />
          </div>
        </div>

        {/* Note */}
        <div className="grid grid-cols-1 mt-4">
          <div>
            <label className="primary-label">Note</label>
            <textarea
              value={data.note}
              name="note"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["note"] ? "!border-red-600" : ""
              }`}
            />
          </div>
        </div>

        {/* Submit */}
        <div className="flex items-center justify-center mt-12">
          <button
            onClick={() => handleSubmit()}
            className={`button-primary !w-[210px]`}
          >
            {loading ? <LoadingDots /> : "Add Journal Transaction"}
          </button>
        </div>
      </div>
    </main>
  );
};

export default AddJournalTransaction;
